import { Component, Vue } from "vue-property-decorator";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";

@Component({})
export default class UserValidator extends Vue {
  isSuperAdmin(): boolean {
    const roles = localStorage.getItem("roles");
    return roles.includes("ROLE_SUPER_ADMIN");
  }
  isWebinarUser(): boolean {
    const spaceUser: SpaceUserInterface =
      this.$store.getters["UserStore/getSpaceUser"];
    const roles = localStorage.getItem("roles");
    return !roles.includes("ROLE_SUPER_ADMIN") ? spaceUser.isWebinarHost : true;
  }
  isMultiWebinarUser(): boolean {
    const spaceUser: SpaceUserInterface =
      this.$store.getters["UserStore/getSpaceUser"];
    const roles = localStorage.getItem("roles");
    return !roles.includes("ROLE_SUPER_ADMIN")
      ? spaceUser.superSpaceUser.isWebinarHost
      : true;
  }
  isAdmin(): boolean {
    const spaceUser: SpaceUserInterface =
      this.$store.getters["UserStore/getSpaceUser"];

    const roles = localStorage.getItem("roles");
    return !roles.includes("ROLE_SUPER_ADMIN")
      ? !spaceUser.superSpaceUser.isAdmin
        ? spaceUser.isAdmin
        : true
      : true;
  }
  isAdminBySpaceUser(spaceUser: SpaceUserInterface): boolean {
    const roles = localStorage.getItem("roles");
    return !roles.includes("ROLE_SUPER_ADMIN")
      ? !spaceUser.superSpaceUser.isAdmin
        ? spaceUser.isAdmin
        : true
      : true;
  }
  isSuperSpaceAdmin() {
    const spaceUser: SpaceUserInterface =
      this.$store.getters["UserStore/getSpaceUser"];
    const roles = localStorage.getItem("roles");
    return !roles.includes("ROLE_SUPER_ADMIN")
      ? spaceUser.superSpaceUser.isAdmin
      : true;
  }
  isSuperSpaceOwner(): boolean {
    const space = this.$store.getters["SpaceStore/getSpace"];
    const user = this.$store.getters["UserStore/getSpaceUser"];
    const roles = localStorage.getItem("roles");
    return !roles.includes("ROLE_SUPER_ADMIN")
      ? (space.superSpace.createdBy.id === user.superSpaceUser.user.id ||
        user.superSpaceUser.isAdmin) &&
      space.superSpace.isExpandable
      : true;
  }
  isSuperSpaceOwnerByUserSpace(spaceUser: SpaceUserInterface): boolean {
    const space = this.$store.getters["SpaceStore/getSpace"];
    const roles = localStorage.getItem("roles");
    return !roles.includes("ROLE_SUPER_ADMIN")
      ? (space.superSpace.createdBy.id === spaceUser.superSpaceUser.user.id ||
        spaceUser.superSpaceUser.isAdmin) &&
      space.superSpace.isExpandable
      : true;
  }
  canInvite(): boolean {
    const spaceUser: SpaceUserInterface =
      this.$store.getters["UserStore/getSpaceUser"];
    const roles = localStorage.getItem("roles");
    return !roles.includes("ROLE_SUPER_ADMIN")
      ? !spaceUser.superSpaceUser.canInvite
        ? spaceUser.canInvite
        : true
      : true;
  }
  canSendConsoleMessage(): boolean {
    const spaceUser: SpaceUserInterface =
      this.$store.getters["UserStore/getSpaceUser"];

    const roles = localStorage.getItem("roles");
    return !roles.includes("ROLE_SUPER_ADMIN")
      ? !spaceUser.superSpaceUser.canSendConsoleMessage
        ? spaceUser.canSendConsoleMessage
        : true
      : true;
  }
  canSendCampusConsoleMessage(): boolean {
    const spaceUser: SpaceUserInterface =
      this.$store.getters["UserStore/getSpaceUser"];

    const roles = localStorage.getItem("roles");
    return !roles.includes("ROLE_SUPER_ADMIN")
      ? spaceUser.superSpaceUser.canSendConsoleMessage
      : true;
  }
  canChangeRoomPin(): boolean {
    const spaceUser: SpaceUserInterface =
      this.$store.getters["UserStore/getSpaceUser"];
    const space = this.$store.getters["SpaceStore/getSpace"];

    const roles = localStorage.getItem("roles");
    return !roles.includes("ROLE_SUPER_ADMIN")
      ? !spaceUser.superSpaceUser.canChangeRoomPin &&
        !spaceUser.superSpaceUser.isAdmin
        ? spaceUser.canChangeRoomPin ||
        spaceUser.isAdmin ||
        space.createdBy.id === spaceUser.superSpaceUser.user.id ||
        space.superSpace.createdBy.id == spaceUser.superSpaceUser.user.id
        : true
      : true;
  }
  isGuest(): boolean {
    const city = localStorage.getItem("city") == "ON" ? true : false;
    let user = null;
    if (city) {
      const data = {
        user: this.$store.getters["UserStore/getUser"],
      };
      user = data;
      return user.user.isGuest;
    } else user = this.$store.getters["UserStore/getSpaceUser"];
    return user.superSpaceUser.user.isGuest;
  }
  canBan(): boolean {
    const spaceUser: SpaceUserInterface =
      this.$store.getters["UserStore/getSpaceUser"];

    const roles = localStorage.getItem("roles");
    return !roles.includes("ROLE_SUPER_ADMIN")
      ? !spaceUser.superSpaceUser.canBan
        ? spaceUser.canBan
        : true
      : true;
  }
  canPinChatMessage(): boolean {
    //canCreatePinChatMessage
    const spaceUser: SpaceUserInterface =
      this.$store.getters["UserStore/getSpaceUser"];
    return !spaceUser.superSpaceUser.canPinChatMessage
      ? spaceUser.canPinChatMessage
      : true;
  }
  canManagerWebinar(): boolean {
    const spaceUser: SpaceUserInterface =
      this.$store.getters["UserStore/getSpaceUser"];
    const roles = localStorage.getItem("roles");
    return !roles.includes("ROLE_SUPER_ADMIN")
      ? !spaceUser.superSpaceUser.canManageWebinar
        ? spaceUser.canManageWebinar
        : true
      : true;
  }
  canManageMeetingControl(): boolean {
    const spaceUser: SpaceUserInterface =
      this.$store.getters["UserStore/getSpaceUser"];
    const roles = localStorage.getItem("roles");
    return !roles.includes("ROLE_SUPER_ADMIN")
      ? !spaceUser.superSpaceUser.canManageMeetingControl
        ? spaceUser.canManageMeetingControl
        : true
      : true;
  }
}
